// Mirrors trpc.rota.hours.week (apps/web/src/api/trpc/routers/rota.ts).

export type HoursPlanned = {
  shift_id: number;
  date: string;
  start_time: string;
  end_time: string;
  break_minutes: number;
  role_name: string | null;
  hours: number;
};

export type HoursEntry = {
  id: number;
  date: string;
  clock_in: string;
  clock_out: string | null;
  source: "link" | "manager";
  note: string | null;
  shift_id: number | null;
  hours: number;
};

export type HoursPerson = {
  staff_id: number;
  name: string;
  color: string | null;
  contract_hours_week: number | null;
  hourly_rate: number | null;
  planned_hours: number;
  worked_hours: number;
  planned: HoursPlanned[];
  entries: HoursEntry[];
};

export type HoursWeek = {
  timezone: string;
  net_sales: number;
  food_cost: number;
  can_see_wages: boolean;
  people: HoursPerson[];
};

/** Labour cost, and its share of sales together with food cost (prime cost). */
export function labourTotals(week: HoursWeek) {
  let cost = 0;
  let missingRate = 0;
  for (const p of week.people) {
    if (!p.worked_hours) continue;
    if (p.hourly_rate == null) missingRate++;
    else cost += p.worked_hours * p.hourly_rate;
  }
  const pct = (v: number) => (week.net_sales > 0 ? (v / week.net_sales) * 100 : null);
  return {
    planned: week.people.reduce((s, p) => s + p.planned_hours, 0),
    worked: week.people.reduce((s, p) => s + p.worked_hours, 0),
    cost,
    missingRate,
    labourPct: pct(cost),
    primePct: pct(cost + week.food_cost),
  };
}
